import styled, { css } from 'styled-components';
import { Container } from 'reactstrap';
import { Loading, Alert } from '@whitelabel/component-library';
import { backgroundStyles, backgroundImage } from '@whitelabel/helpers/style/utils';
import { fontStyle } from '@whitelabel/helpers/style/type';
import { themeColor, color } from '@whitelabel/helpers/style/colors';
import { borderRadius } from '@whitelabel/helpers/style/box';
import { mediaBreakpointDown, mediaBreakpointUp } from '@whitelabel/helpers/style/grid';
import helpCenterImg from '../../media/banners/help-center.jpg';
import helpCenterMobileImg from '../../media/banners/help-center-mobile.jpg';
import StyledPrimaryTitle from '../../styled/StyledPrimaryTitle';

export const StyledBGContainer = styled.div<{ $rtl: boolean; $hideBottomBoxOnDesktop?: boolean }>`
  display: flex;
  align-items: center;
  min-height: 7.875rem;
  margin-top: -1.5rem;

  ${backgroundStyles}

  ${mediaBreakpointDown('sm')`
    ${backgroundImage(helpCenterMobileImg)}
  `}
  ${mediaBreakpointUp('md')`
    min-height: 9.125rem;
    margin-top: -2rem;

    ${backgroundImage(helpCenterImg)}
  `}

  ${mediaBreakpointUp('lg')`
    min-height: 13.75rem;
    margin-top: -3rem;
    ${({ $hideBottomBoxOnDesktop }: { $hideBottomBoxOnDesktop: boolean }) =>
      $hideBottomBoxOnDesktop &&
      css`
        margin-bottom: 3rem;
      `}
  `}
`;

export const StyledTitle = styled(StyledPrimaryTitle)`
  margin-bottom: 0;
`;

export const StyledBottomBox = styled.div<{ $hideOnDesktop?: boolean }>`
  margin-bottom: 1.5rem;
  background: ${themeColor('primary')};

  ${mediaBreakpointUp('md')`
    margin-bottom: 2rem;
  `}

  ${mediaBreakpointUp('lg')`
    ${({ $hideOnDesktop }: { $hideOnDesktop: boolean }) =>
      $hideOnDesktop &&
      css`
        display: none;
      `}
    margin-bottom: 3rem;
  `}
`;

export const StyledLoginBlock = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 1rem;
  padding-bottom: 1rem;
  text-align: center;

  ${mediaBreakpointUp('md')`
    flex-direction: row;
    justify-content: center;
  `}

  ${mediaBreakpointUp('lg')`
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  `}

  div {
    ${fontStyle('paragraph')};
    margin-bottom: 1rem;

    ${mediaBreakpointUp('md')`
      margin-inline-end: 1.5rem;
      margin-bottom: 0;
      text-align: start;
    `}
  }

  h2 {
    margin-bottom: 0;
    text-transform: initial;

    ${mediaBreakpointUp('md')`
      display: inline-block;
      margin-inline-end: 0.5rem;
    `}
  }
`;

export const StyledPartnersBlock = styled.div`
  padding: 1rem 0;
  background-image: linear-gradient(
    ${color('artyClickSkyBlue')} 0,
    ${color('brightCerulean')} 50.52%,
    ${color('java')} 100%
  );
  ${mediaBreakpointUp('md')`
    padding: 1.5rem 0;
  `}

  ${mediaBreakpointUp('lg')`
    padding: 3rem 0;
  `}
`;

export const StyledWelcomeText = styled.h2<{ $hasPartners: boolean }>`
  color: ${color('white')};
  ${({ $hasPartners }) =>
    $hasPartners
      ? css`
          margin-bottom: 1rem;
          ${mediaBreakpointUp('md')`
            margin-bottom: 1.5rem;
          `}

          ${mediaBreakpointUp('lg')`
            margin-bottom: 3rem;
          `}
        `
      : css`
          margin-bottom: 0;
        `}
`;

export const StyledPartnersBox = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;

  ${mediaBreakpointUp('md')`
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 1.5rem;
  `}

  ${mediaBreakpointUp('lg')`
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 2rem;
  `}

  > div {
    background-color: ${color('white')};
    border-radius: ${borderRadius('base')};
    opacity: 20%;
  }
`;

const marginTop = css`
  margin-top: 1rem;
  ${mediaBreakpointUp('md')`
    margin-top: 1.5rem;
  `}

  ${mediaBreakpointUp('lg')`
    margin-top: 3rem;
  `}
`;

export const StyledLoading = styled(Loading)`
  ${marginTop}
  height: 3.625rem;

  ${mediaBreakpointUp('lg')`
    height: 3.8125rem;
  `}
`;

export const StyledAlert = styled(Alert)`
  ${marginTop}
  margin-bottom: 0;
`;
